import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const BookSignings = () => <EventCategoryPage config={EVENT_CATEGORIES['book-signings']} data-id="element-9846" data-mp="b74bn7gvls1l" />;
export default BookSignings;